module.exports = __webpack_public_path__ + "img/cplusplus.89e60026.svg";